/**
 * Blog guides for SEO. Long-form articles live in longPostsA/B/C/Ai/Funnel/FileSend/Latam/Professions/Companies/Spain/Wave5/Wave6 + privacy.
 * Keep related slugs valid; update public/sitemap.xml when adding posts.
 */

import longPostsA from './longPostsA';
import longPostsB from './longPostsB';
import longPostsC from './longPostsC';
import longPostsAi from './longPostsAi';
import longPostsFunnel from './longPostsFunnel';
import longPostsFileSend from './longPostsFileSend';
import longPostsFileSendB from './longPostsFileSendB';
import longPostsLatam from './longPostsLatam';
import longPostsProfessions from './longPostsProfessions';
import longPostsCompanies from './longPostsCompanies';
import longPostsSpain from './longPostsSpain';
import longPostsSpainB from './longPostsSpainB';
import longPostsWave5 from './longPostsWave5';
import longPostsWave6 from './longPostsWave6';
import longPostsPrivacy from './longPostsPrivacy';

const posts = [
  ...longPostsWave6,
  ...longPostsPrivacy,
  ...longPostsWave5,
  ...longPostsSpain,
  ...longPostsSpainB,
  ...longPostsCompanies,
  ...longPostsProfessions,
  ...longPostsLatam,
  ...longPostsFileSend,
  ...longPostsFileSendB,
  ...longPostsFunnel,
  ...longPostsAi,
  ...longPostsA,
  ...longPostsB,
  ...longPostsC,
].sort(
  (a, b) => new Date(b.date) - new Date(a.date) || a.slug.localeCompare(b.slug)
);

export const getAllPosts = () => posts;
export const getPostBySlug = (slug) => posts.find((p) => p.slug === slug) || null;
export const getPostsByCategory = (category) =>
  posts.filter((p) => p.category === category);
export const getLocalizedPost = (post, lang) => {
  const locale = lang === 'en' ? 'en' : 'es';
  return {
    slug: post.slug,
    date: post.date,
    category: post.category,
    related: post.related || [],
    ...post[locale],
  };
};
export const getRelatedPosts = (post, lang, limit = 3) => {
  const slugs = post.related || [];
  const found = slugs.map((s) => getPostBySlug(s)).filter(Boolean).map((p) => getLocalizedPost(p, lang));
  if (found.length >= limit) return found.slice(0, limit);
  const extras = getAllPosts()
    .filter((p) => p.slug !== post.slug && !slugs.includes(p.slug))
    .slice(0, limit - found.length)
    .map((p) => getLocalizedPost(p, lang));
  return [...found, ...extras].slice(0, limit);
};
export const CATEGORY_LABELS = {
  es: { ats: 'ATS y filtros', writing: 'Redacción', format: 'Formato', career: 'Carrera', language: 'Idioma', privacy: 'Privacidad', ai: 'IA y ChatGPT' },
  en: { ats: 'ATS & filters', writing: 'Writing', format: 'Format', career: 'Career', language: 'Language', privacy: 'Privacy', ai: 'AI & ChatGPT' },
};
export default posts;
